import { render, staticRenderFns } from "./StsAccordion.vue?vue&type=template&id=7e6b8202&scoped=true"
import script from "./StsAccordion.vue?vue&type=script&lang=js"
export * from "./StsAccordion.vue?vue&type=script&lang=js"
import style0 from "./StsAccordion.vue?vue&type=style&index=0&id=7e6b8202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6b8202",
  null
  
)

export default component.exports